import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Software Backup">
        <EuiText>
          <p>
            Sichern Sie Ihre Kameraeinstellungen in einer Datei.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

